module.exports = __webpack_public_path__ + "static/media/paymentCharge.a538249f.png";